export default {
  q_2_8b: [
    {
      comment:
        "Wydarzenia sponsorowane  wyłącznie przez jedną firmę bez udostępnienia możliwości udziału w wydarzeniu innym firmom nie podlegają weryfikacji w systemie.  Takie wydarzenie jest wydarzeniem firmowym.",
      title: "Standardowy szablon"
    }
  ],
  date: {
    dateStart: [
      {
        title: "Standardowy szablon",
        comment:
          "Uwaga! Wydarzenie organizowane w sezonie atrakcyjnym turystycznie w danej lokalizacji. Więcej szczegółów znajduje się w kryteriach weryfikacji wydarzeń dostępnych TUTAJ [link do kryteriów]."
      }
    ]
  },
  locations: {
    city: [
      {
        title: "Standardowy szablon",
        comment:
          "Uwaga! Wydarzenie organizowane w sezonie atrakcyjnym turystycznie w danej lokalizacji. Więcej szczegółów znajduje się w kryteriach weryfikacji wydarzeń dostępnych TUTAJ [link do kryteriów]."
      }
    ],
    type: [
      {
        title: "Standardowy szablon",
        comment:
          "UWAGA! Niewłaściwy charakter lub standard obiektu (np. istotna oferta wypoczynkowa/turystyczna/ rozrywkowa, obiekt ma charakter luksusowy). Więcej szczegółów znajduje się w kryteriach weryfikacji wydarzeń dostępnych TUTAJ [link do kryteriów]."
      }
    ],
    features: [
      {
        title: "Standardowy szablon",
        comment:
          "UWAGA! Niewłaściwy charakter lub standard obiektu (np. istotna oferta wypoczynkowa/turystyczna/ rozrywkowa, obiekt ma charakter luksusowy). Więcej szczegółów znajduje się w kryteriach weryfikacji wydarzeń dostępnych TUTAJ [link do kryteriów]."
      }
    ]
  }
};
